import { useClientPortalAPI } from "@certn/api";
import { useAuth } from "@certn/auth";

import { useOptionalClientPortalBootstrap } from "../providers/clientPortalBootstrapContext";

export function useUser() {
  const { user, logout, isAuthenticated } = useAuth();
  const bootstrap = useOptionalClientPortalBootstrap();

  const fallback = useClientPortalAPI(
    bootstrap || !isAuthenticated ? null : "/api/internal/client-portal/me/",
    undefined,
    {
      onError: (error) => error?.status === 401 && logout(),
    }
  );

  if (bootstrap) {
    return {
      user,
      details: bootstrap.userDetails,
      isLoading: bootstrap.isAuthorizationPending,
      error: bootstrap.authorizationError,
      mutate: bootstrap.mutateUser,
    };
  }

  return {
    user,
    details: fallback.data,
    isLoading: fallback.isLoading,
    error: fallback.error,
    mutate: fallback.mutate,
  };
}
